var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.557,
    height: 36.557,
    viewBox: "0 0 36.557 36.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.261 12.215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.079,
    cy: 4.079,
    r: 4.079,
    transform: "translate(0 4.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.499,
    cy: 0.499,
    r: 0.499,
    transform: "translate(3.58 7.868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.503 5.14v-2.4A2.57 2.57 0 014.034-.001h.088A2.566 2.566 0 016.648 2.74v2.4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.505 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.789 3.865V9.01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.589 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.789 3.865V9.01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.505 26.914)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732,
    transform: "translate(0 5.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.789 5.145V0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.589 26.914)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732,
    transform: "translate(0 5.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.789 5.145V0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.788 12.504)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732,
    transform: "translate(5.306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.145 1.915H0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.788 20.589)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732,
    transform: "translate(5.306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.145 1.915H0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 12.504)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.739 1.915h5.145"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 20.589)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.732,
    cy: 1.732,
    r: 1.732
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.739 1.915h5.145"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityToken);
export default __webpack_public_path__ + "static/media/securityToken.3e847d2ea95aea04412438ffe7c8f5e5.svg";
export { ForwardRef as ReactComponent };